import { Box, Grid, makeStyles } from '@material-ui/core';
import TextOrLoading from './TextOrLoading';

export default function GestaoAVistaEtapasSemaforo({
  etapasNoPrazo,
  etapasARealizar,
  etapasVencendo,
  etapasVencidas,
  selected, // "prazo" | "vencendo" | "vencida"
  onSelectedChange,
  loading = false,
}) {
  return (
    <Box
      style={{
        marginTop: 12,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}
    >
      <EtapaSemaforo
        loading={loading}
        number={etapasNoPrazo}
        label="Etapas realizadas no prazo"
        backgroundColor="#00b050"
        selected={selected === 'PRAZO'}
        onClick={() => onSelectedChange('PRAZO')}
      />
      <EtapaSemaforo
        loading={loading}
        number={etapasARealizar}
        label="Etapas a realizar"
        backgroundColor="#0070c0"       
        selected={selected === 'REALIZAR'}
        onClick={() => onSelectedChange('REALIZAR')}
      />
      <EtapaSemaforo
        loading={loading}
        number={etapasVencendo}
        label="Etapas vencendo em 48 horas"
        backgroundColor="#ffff00"
        selected={selected === 'VENCENDO'}
        onClick={() => onSelectedChange('VENCENDO')}
        dark
      />
      <EtapaSemaforo
        loading={loading}
        number={etapasVencidas}
        label="Etapas fora do prazo"
        backgroundColor="#ff0000"
        selected={selected === 'VENCIDA'}
        onClick={() => onSelectedChange('VENCIDA')}
      />
    </Box>
  );
}

const useStyles = makeStyles({
  button: {
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
  },
  semaforoIcon: {
    minWidth: 16,
    minHeight: 16,
    width: 16,
    height: 16,
    borderRadius: 9999,
    borderStyle: 'solid',
    borderColor: '#000',
    marginRight: 12,
  },
  etapaLabel: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 24,
    paddingRight: 24,
    borderRadius: 8,
    color: '#fff',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: 'transparent',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  number: { display: 'block', fontWeight: 'bold', fontSize: 18, color: 'inherit' },
  label: { display: 'block', color: 'inherit' },
});

const EtapaSemaforo = ({ number, label, backgroundColor, selected, onClick, dark = false, loading = false }) => {
  const classes = useStyles();

  return (
    <Box>
      <button type="button" className={classes.button} onClick={onClick}>
        <Box className={classes.semaforoIcon} style={{ backgroundColor, borderWidth: selected ? 2 : 1 }} />
        <Box
          className={classes.etapaLabel}
          style={{ backgroundColor, borderColor: selected ? '#000' : 'transparent', color: dark ? '#000' : '#fff' }}
        >
          <TextOrLoading loading={loading} loadingSize={16}>
            <strong className={classes.number}>{number ?? 0}</strong>
          </TextOrLoading>
          <span className={classes.label}>{label}</span>
        </Box>
      </button>
    </Box>
  );
};
